/*
 * PDE - JavaScript
 * Copyright 2010. All rights reserved.
 *
 * Class: Loader
 * Description: A loading icon that attaches to whatever it wants.
 */
var Loader = new Class
({
	Implements: Options,
	options:
	{
		cls: 'w_loader',
		msg: 'loading',
		off:
		{
			x: 0,
			y: 0
		},
		hasSpan: true
	},
	initialize: function(element, options)
	{
		this.setOptions(options);
		this.charge = 0;
		this._attach = document.id(element);

		this.make();
		this.attach(this._attach);
	},
	plus: function()
	{
		if (this.charge == 0)
		{
			this.show();
		}
		this.charge++;
	},
	minus: function()
	{
		this.charge--;
		if (this.charge == 0)
		{
			this.hide();
		}
	},
	make: function()
	{
		var opts = this.options, doc = document.id(document.body);
		this._element = new Element('div',
		{
			'class': opts.cls,
			styles:
			{
				position: 'absolute'
			}
		}).inject(doc);
		this._element.setStyle('opacity', 0);
		
		if(opts.hasSpan) {
			this._msg = new Element('span',
			{
				text: opts.msg
			}).inject(this._element);
		}
				
		this.fx = new Fx.Morph(this._element, {duration: 300, link: 'cancel'});
	},
	attach: function(f)
	{
		var coor = f.getCoordinates(), off = this.options.off;
		this._element.setStyles(
		{
			top: coor.top+off.y,
			left: coor.left+off.x
		});
	},
	show: function()
	{
		this.timer = this.timedClose.bind(this).delay(5500);
		this._element.setStyle('opacity', 1);
	},
	hide: function()
	{
		clearTimeout(this.timer);
		this._element.setStyle('opacity', 0);
	},
	timedClose: function()
	{
		this.charge = 0;
		this.hide();
	}
});